// import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { Contract } from '@contracts/interfaces/contract';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import ManageContractBookingsTable from '@bookings/components/tables/manage-contract-bookings-table/manage-contract-bookings-table.vue';
import { isNull } from 'lodash';
import ModulesHelper from '@core/services/modules.helper';
import BulkRenewalContractActionsModal from '@contracts/components/modals/bulk-renewal-contract-actions-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BPCMessageService from '@core/services/bpc-messages.service';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import DownloadPdfUsingTemplateMixin from '@shared/components/tables/abstract-table/download-pdf-using-template-mixing';
import ContractForm from '@contracts/components/forms/contract-form.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';

const bpcMessage = new BPCMessageService();

library.add(faPlus);

@Component({
  name: 'bpc-contract-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-select': EntitySelect,
    'bpc-date-picker': Datepicker,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
    'bpc-manage-contract-bookings-table': ManageContractBookingsTable,
    'bpc-bulk-renewal-contract-actions-modal': BulkRenewalContractActionsModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-contract-form': ContractForm,
  },
})
export default class ContractTable extends mixins(
  AbstractTable,
  SendMessageUsingTemplateMixin,
  DownloadPdfUsingTemplateMixin,
) {
  $refs: AbstractTable['$refs'] & {
    requestContractConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    proposeContractConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    confirmContractConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    cancelContractConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    renewContractConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    requestContractBookingsTable: InstanceType<typeof ManageContractBookingsTable> & {
      bookings: any[];
    };
  };
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: Contract = null;
  public entityName = 'contract';
  public pluralEntityName = 'contracts';
  public selectedPeriode = null;
  public startDate: string = null;
  public endDate: string = null;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  // Page actions
  public customPageActions = {
    bulkSendMessageUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'envelope', //'times',
      variant: 'info',
      text: 'send_message_using_template',
      show: false,
      event: 'bulk-send-message-using-template',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_message'],
    },
    bulkDownloadPdfUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'download', //'times',
      variant: 'info',
      text: 'download_pdf_using_template',
      show: false,
      event: 'bulk-download-pdf-using-template',
      selectElements: true,
      tag: 'left',
      permissions: ['show'],
    },
    bulkActions: {
      activated: false,
      type: 'dropdown',
      icon: 'cubes',
      variant: 'info',
      text: 'bulk_actions',
      show: false,
      event: '',
      selectElements: true,
      tag: 'bulk',
      permissions: [],
      children: {
        renewalHead: {
          activated: false,
          type: 'head',
          text: 'renewal-head',
          show: false,
          withoutDivider: true,
          permissions: [],
        },
        bulkRenew: {
          activated: false,
          type: 'dropdown-item',
          text: 'renew-contracts',
          show: false,
          icon: 'redo',
          event: 'bulk-renew-contract',
          permissions: ['renew_contract'],
        },
        bulkPropose: {
          activated: false,
          type: 'dropdown-item',
          text: 'propose-contracts',
          show: false,
          icon: 'check',
          event: 'bulk-propose-contract',
          permissions: ['propose_contract'],
        },
        bulkConfirm: {
          activated: false,
          type: 'dropdown-item',
          text: 'confirm-contracts',
          show: false,
          icon: 'check',
          event: 'bulk-confirm-contract',
          permissions: ['confirm_contract'],
        },
      },
    },
  };

  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-renew-contract':
        this.onBulkRenewContract();
        break;
      case 'bulk-propose-contract':
        this.onBulkProposeContract();
        break;
      case 'bulk-confirm-contract':
        this.onBulkConfirmContract();
        break;
      case 'bulk-send-message-using-template':
        this.onBulkSendMessageUsingTemplate(this.selection);
        break;
      case 'bulk-download-pdf-using-template':
        this.onBulkDownloadPdfUsingTemplate(this.selection);
        break;
    }
  }

  showBulkRenewalContractActionModal: boolean = false;
  selectedRenewalContractAction: string = null;

  onBulkRenewContract() {
    this.selectedRenewalContractAction = 'renew';
    this.showBulkRenewalContractActionModal = true;
  }
  onBulkProposeContract() {
    this.selectedRenewalContractAction = 'propose';
    this.showBulkRenewalContractActionModal = true;
  }
  onBulkConfirmContract() {
    this.selectedRenewalContractAction = 'confirm';
    this.showBulkRenewalContractActionModal = true;
  }
  onCLoseBulkRenewalContractActionModal() {
    this.showBulkRenewalContractActionModal = false;
  }
  onSuccessBulkRenewalContractAction() {
    this.$refs.provider.getEntities();
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.bulkDownloadPdfUsingTemplate.show =
      this.availableTemplatesForDownloadPdf?.length &&
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    this.customPageActions.bulkActions.show = this.tableIsNotFilteredByTrashedElements();
    this.customPageActions.bulkActions.children.renewalHead.show = this.tableIsNotFilteredByTrashedElements();
    this.customPageActions.bulkActions.children.bulkRenew.show = this.tableIsNotFilteredByTrashedElements();
    this.customPageActions.bulkActions.children.bulkPropose.show = this.tableIsNotFilteredByTrashedElements();
    this.customPageActions.bulkActions.children.bulkConfirm.show = this.tableIsNotFilteredByTrashedElements();
    this.customPageActions.bulkSendMessageUsingTemplate.show =
      this.tableIsNotFilteredByTrashedElements() &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
  }

  // Row actions
  public customRowActions = {
    proposeContract: {
      activated: false,
      type: 'action',
      icon: 'check',
      show: false,
      event: 'propose-contract',
      text: 'propose-contract',
      permissions: ['propose_contract'],
    },
    requestContract: {
      activated: false,
      type: 'action',
      icon: 'check',
      show: false,
      event: 'request-contract',
      text: 'request-contract',
      permissions: ['request_contract'],
    },
    renewContract: {
      activated: false,
      type: 'action',
      icon: 'redo',
      show: false,
      event: 'renew-contract',
      text: 'renew-contract',
      permissions: ['renew_contract'],
    },
    confirmContract: {
      activated: false,
      type: 'action',
      icon: 'check',
      show: false,
      event: 'confirm-contract',
      text: 'confirm-contract',
      permissions: ['confirm_contract'],
    },
    cancelContract: {
      activated: false,
      type: 'action',
      icon: 'ban',
      show: false,
      event: 'cancel-contract',
      text: 'cancel-contract',
      permissions: ['cancel_contract'],
    },
    sendMessageUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'envelope',
      show: false,
      event: 'send-message-using-template',
      text: 'send_message_using_template',
      permissions: ['send'],
    },

    // NOTE for the moment we disable the action to download the PDF using a
    // template we have to clarify if we put this action here or other
    // to download the attached documents of each contract
    downloadPdfUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'download',
      show: false,
      event: 'download-pdf-using-template',
      text: 'download_pdf_using_template',
      permissions: ['show'],
    },
  };

  loadingRowAction: boolean = false;
  selectedContract: Contract = null;
  showSelectedContractBookings: boolean = false;
  showContractModalForm: boolean = false;
  showRenewContractModalForm: boolean = false;
  generatingDocuments: boolean = false;

  get rowActions() {
    return {
      ...this.customRowActions,
      ...this.defaultRowActions,
    };
  }

  mounted() {
    const templatesRequest = [
      // this.getAllowedTemplatesForSendMessage(),
      this.getAllowedTemplatesForDownloadPdf(),
    ];

    Promise.all(templatesRequest).then(res => {
      this.updateRowActions();
      this.updatePageActions();
    });
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'request-contract':
        this.onRequestContract($event.item);
        break;
      case 'propose-contract':
        this.onProposeContract($event.item);
        break;
      case 'confirm-contract':
        this.onConfirmContract($event.item);
        break;
      case 'renew-contract':
        this.onRenewContract($event.item);
        break;
      case 'cancel-contract':
        this.onCancelContract($event.item);
        break;
      case 'send-message-using-template':
        this.onSendMessageUsingTemplate($event.item.item);
        break;
      case 'download-pdf-using-template':
        this.onDownloadPdfUsingTemplate($event.item.item);
        break;
    }
  }

  async generateAndDownloadPdf(contractId = null, overwriteBody = true, updateDocument = false) {
    this.generatingDocuments = true;
    const entityModel = this.$refs.stdForm.formModel as Contract;
    const selectedId = contractId ? contractId : entityModel.id;
    const path = `${this.$bpcApiRouteHelper.getEntityPath(
      'contracts',
    )}/${selectedId}/generate-document-pdf`;
    const formModel = overwriteBody
      ? {
          body: entityModel.document_template_body,
          template_id: entityModel.template.id,
          update_document: updateDocument,
        }
      : {};
    await this.$bpcApi.postDownload(path, '', formModel).toPromise();
    this.generatingDocuments = false;
  }

  async saveGenerateAndDownloadDocumentPdf(contractId = null, overwriteBody = true) {
    this.generatingDocuments = true;
    // NOTE The form is saved before generating the document but we keep
    // the endpoint to generate the PDF  working as before.
    await this.$refs.stdForm.saveEntity();
    const updateDocument = true;
    await this.generateAndDownloadPdf(contractId, overwriteBody, updateDocument);
    this.generatingDocuments = false;
    this.$root.$emit('refreshContractDocumentList');
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.proposeContract.show =
      this.tableIsNotFilteredByTrashedElements() && entity.status === 'draft';

    entity.actions.requestContract.show =
      this.tableIsNotFilteredByTrashedElements() && entity.status === 'proposed';

    entity.actions.confirmContract.show =
      this.tableIsNotFilteredByTrashedElements() && entity.status === 'requested';

    entity.actions.renewContract.show =
      this.tableIsNotFilteredByTrashedElements() && entity.status === 'confirmed';

    entity.actions.cancelContract.show =
      this.tableIsNotFilteredByTrashedElements() && entity.status !== 'cancelled';

    entity.actions.sendMessageUsingTemplate.show =
      this.tableIsNotFilteredByTrashedElements() &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);

    entity.actions.downloadPdfUsingTemplate.show =
      this.availableTemplatesForDownloadPdf?.length &&
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash';
  }

  onShow(contract) {
    this.selectedContract = contract['item'];
    this.showContractModalForm = true;
  }

  onCloseShowContractModalForm() {
    this.showContractModalForm = false;
  }

  onProposeContract(contract) {
    this.selectedContract = contract['item'];
    // If the contract is type booking, show and manage its
    if (this.selectedContract.contract_type === 'bookings') {
      this.showSelectedContractBookings = true;
    }
    this.$refs.proposeContractConfirmationModal.onOpenModal(contract['item']['id']);
  }

  onConfirmProposeContract($event) {
    this.loadingRowAction = true;
    const entityId = $event['entityIdOrIds'];
    const path = this.$bpcApiRouteHelper.getEntityPath(this.entityName) + '/propose/' + entityId;

    this.$bpcApi.post(path).subscribe(
      (res: BPCGenericApiResponse) => {
        this.$refs.proposeContractConfirmationModal.onCloseModal();
        this.$refs.provider.getEntities();
      },
      error => {
        console.log(error);
        this.loadingRowAction = false;
      },
      () => {
        this.loadingRowAction = false;
      },
    );
  }

  onRequestContract(contract) {
    this.selectedContract = contract['item'];
    // If the contract is type booking, show and manage its
    if (this.selectedContract.contract_type === 'bookings') {
      this.showSelectedContractBookings = true;
    }
    this.$refs.requestContractConfirmationModal.onOpenModal(contract['item']['id']);
  }

  onConfirmRequestContract($event) {
    this.loadingRowAction = true;
    const entityId = $event['entityIdOrIds'];
    const path = this.$bpcApiRouteHelper.getEntityPath(this.entityName) + '/request/' + entityId;
    const body = {};
    const contractCanBeRequested = { result: true, reasons: [] };

    if (this.selectedContract.contract_type === 'bookings') {
      body['bookingEventsToRequest'] = [];
      this.$refs.requestContractBookingsTable.bookings.forEach(booking => {
        // Check if the booking can be requested or exceed the max number of events
        if (booking.max_events) {
          const eventsToRequest = booking.bookingEvents?.filter(
            event => event.action === 'request',
          );
          const eventsConfirmed = booking.bookingEvents?.filter(
            event => event.status === 'confirmed',
          );

          const totalBookingEvents = eventsToRequest?.length + eventsConfirmed?.length;
          if (totalBookingEvents > booking.max_events) {
            contractCanBeRequested.result = false;
            contractCanBeRequested.reasons.push(
              this.$t('global.contracts.errors.specified-booking-exceed-max-events', {
                code: booking.code,
                total: totalBookingEvents,
                max: booking.max_events,
              }) as string,
            );
          }
        }

        // Get all the booking events that have to be requested
        booking.bookingEvents?.forEach(event => {
          if (event.action === 'request') {
            body['bookingEventsToRequest'].push(event.id);
          }
        });
      });
    }

    if (contractCanBeRequested.result) {
      this.$bpcApi.post(path, body).subscribe(
        (res: BPCGenericApiResponse) => {
          this.$refs.requestContractConfirmationModal.onCloseModal();
          this.$refs.provider.getEntities();
        },
        error => {
          console.log(error);
          this.loadingRowAction = false;
        },
        () => {
          this.loadingRowAction = false;
        },
      );
    } else {
      this.loadingRowAction = false;
      contractCanBeRequested.reasons.forEach(reason => {
        bpcMessage.showErrorMessage({ text: reason });
      });
    }
  }

  onConfirmContract(contract) {
    this.selectedContract = contract['item'];
    // If the contract is type booking, show and manage its
    if (this.selectedContract.contract_type === 'bookings') {
      this.showSelectedContractBookings = true;
    }
    this.$refs.confirmContractConfirmationModal.onOpenModal(contract['item']['id']);
  }

  onConfirmConfirmContract($event) {
    this.loadingRowAction = true;
    const entityId = $event['entityIdOrIds'];
    const path = this.$bpcApiRouteHelper.getEntityPath(this.entityName) + '/confirm/' + entityId;

    this.$bpcApi.post(path).subscribe(
      (res: BPCGenericApiResponse) => {
        this.$refs.confirmContractConfirmationModal.onCloseModal();
        this.$refs.provider.getEntities();
      },
      error => {
        console.log(error);
        this.loadingRowAction = false;
      },
      () => {
        this.loadingRowAction = false;
      },
    );
  }

  onRenewContract(contract) {
    this.selectedContract = contract['item'];
    this.showRenewContractModalForm = true;
    this.$refs.renewContractConfirmationModal.onOpenModal(contract['item']['id']);
  }

  onCloseRenewContract() {
    this.selectedContract = null;
    this.showRenewContractModalForm = false;
  }

  onConfirmRenewContract($event) {
    this.loadingRowAction = true;
    const entityId = $event['entityIdOrIds'];
    const path = this.$bpcApiRouteHelper.getEntityPath(this.entityName) + '/renew/' + entityId;
    const body = {
      start_date: this.startDate,
      end_date: this.endDate,
      period_id: this.selectedPeriode.id,
    };

    this.$bpcApi.post(path, body).subscribe(
      (res: BPCGenericApiResponse) => {
        this.$refs.renewContractConfirmationModal.onCloseModal();
        this.$refs.provider.getEntities();
      },
      error => {
        console.log(error);
        this.loadingRowAction = false;
      },
      () => {
        this.loadingRowAction = false;
      },
    );
  }

  onCancelContract(contract) {
    this.selectedContract = contract['item'];
    this.$refs.cancelContractConfirmationModal.onOpenModal(contract['item']['id']);
  }

  onConfirmCancelContract($event) {
    this.loadingRowAction = true;
    const entityId = $event['entityIdOrIds'];
    const path = this.$bpcApiRouteHelper.getEntityPath(this.entityName) + '/cancel/' + entityId;

    this.$bpcApi.post(path).subscribe(
      (res: BPCGenericApiResponse) => {
        this.$refs.cancelContractConfirmationModal.onCloseModal();
        this.$refs.provider.getEntities();
      },
      error => {
        console.log(error);
        this.loadingRowAction = false;
      },
      () => {
        this.loadingRowAction = false;
      },
    );
  }

  tableIsNotFilteredByTrashedElements() {
    return (
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed
    );
  }

  // Config for confirmation modals
  getProposeContractConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-propose-modal',
      title: this.$t('global.modals.contract-propose.title'),
      body: this.$t('global.modals.contract-propose.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.propose') as string,
      acceptButtonVariant: 'info',
    };
  }

  getRequestContractConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-request-modal',
      title: this.$t('global.modals.contract-request.title'),
      body: this.$t('global.modals.contract-request.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.request') as string,
      acceptButtonVariant: 'info',
    };
  }

  getConfirmContractConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-confirm-modal',
      title: this.$t('global.modals.contract-confirm.title'),
      body: this.$t('global.modals.contract-confirm.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  getCancelContractConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-cancel-modal',
      title: this.$t('global.modals.contract-cancel.title'),
      body: this.$t('global.modals.contract-cancel.body') as string,
      cancelText: this.$t('global.buttons.close') as string,
      acceptText: this.$t('global.buttons.cancel') as string,
      acceptButtonVariant: 'danger',
    };
  }

  getRenewContractConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-renew-modal',
      title: this.$t('global.modals.contract-renew.title'),
      body: this.$t('global.modals.contract-renew.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  constructor() {
    super();
  }

  onFormSaved($event) {
    if (this.generatingDocuments) {
      this.isSavingForm = false;
      return;
    }
    this.$refs.provider.getEntities();
    if (this.entity && 'id' in this.entity) {
      this.onFormClose();
    } else {
      this.onEdit({ item: $event.data });
      this.i++;
    }
    this.isSavingForm = false;
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCloseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }
  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['code', 'name']];

  // Bulk restore modal (recover)
  showBulkRecoverModal = false;
  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }
  onCloseBulkRecover() {
    this.showBulkRecoverModal = false;
  }
  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }
  bulkRecoverDataToShow = [['code', 'name']];

  @Watch('selectedContract')
  onChangeSelectedContract(value) {
    if (isNull(value)) {
      this.showSelectedContractBookings = false;
    }
  }

  @Watch('selectedPeriode')
  onSelectedPeriodIdChange(val) {
    if (val) {
      this.startDate = val.start_date;
      this.endDate = val.end_date;
    }
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
